<template>
  <div class="logo">
    <span class="logo_title is-bold is-img" @click="toindex" style="cursor:pointer;">
      <transition name="fade">
        <template v-if="isCollapse" >
          <img src="@/assets/img/logo1.png" key="0" height="34" />
          <span>logo</span>
        </template>
        <template v-else>
          <img src="@/assets/img/logo3.png" width="114" height="43" />
          <span>展开logo</span>
        </template>
      </transition>
    </span>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'logo',
    data() {
      return {
        logoPath: '',
        logoTextPath:'',
      };
    },
    props: ['isCollapse'],
    created() {

    },
    computed: {
      ...mapGetters(['website', 'loginType']),
    },
    methods: {
      // 回到首页
      toindex() {
        this.$router.push({path: '/index'});
      },
      collapseMenu(){
        this.$store.commit("SET_COLLAPSE");
      }
    }
  };
</script>
<style scoped="scoped" lang="scss">
  .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter-active {
    transition: opacity 2s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .logo {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    overflow: hidden;
    box-sizing: border-box;
    height: 61px;
    padding-left: 14px;
    background-color: #fff;
    border-bottom: 1px solid #E4E7ED;
  }
  .is-img {
    /*position: absolute;*/
    /*top: 10px;*/
    /*left: 13px;*/
    display:flex;
    align-items: center;
    justify-content: center;
  }
  .logo_subtitle {
    font-size: 16px;
    padding-top: 5px;
  }
</style>
